import { Switch } from "@shared/components/DataEntry";

import { useActiveCategorySwitch } from "./controller";
import { ActiveCategorySwitchProps } from "./types";

export function ActiveCategorySwitch(props: ActiveCategorySwitchProps) {
  const { isActive, isPending, toggle } = useActiveCategorySwitch(props);

  return (
    <Switch
      checked={isActive}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
